import { card } from './../../checkout/service/3d-secure';
import { AfterViewInit, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActionButtonFloatingOrder, ActionButtonFloatingOrderEnum, ButtonFloatingOrderService } from '../button-floating-order.service';
import { NavigationEnd, Router } from '@angular/router';
import { Combo2State, PageCombo2Service } from '../../page/component/page-combo2/page-combo2.service';
import { PageSaleService } from '../../page/services/page-sale.service';
import { CartService } from '../../../../projects/shared-lib/src/lib/services/cart.service';
import { ActionCartRequest, ActionCartService, EnumTypeActionCart } from '../../shared/services/action-cart.service';
import { PriceManagerService } from '../../page/services/price-manager.service';
import { CurrencyPipe, JsonPipe, NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatButton, MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslateLangPipe } from '../../../../projects/shared-lib/src/lib/pipe/translate-lang.pipe';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { Parking } from '../../../../projects/shared-lib/src/lib/models/parking';
import { PriceWeb } from '../../../../projects/shared-lib/src/lib/models/price-web';
import { CartDetailToken } from '../../../../projects/shared-lib/src/lib/models/cart-detail-token';
import { CartPrice } from '../../../../projects/shared-lib/src/lib/models/cart-price';
import { CartElement } from '../../../../projects/shared-lib/src/lib/models/cart-element';
import { TwDatePipePipe } from '../../shared/pipe/tw-date-pipe.pipe';
import { PageVenueParkingComponent } from '../../page/component/page-venue-parking/page-venue-parking.component';
import { TemplateHeaderDialogComponent } from '../../templates/template-header-dialog/template-header-dialog.component';
import { SeatMapService } from '../../../../projects/shared-lib/src/lib/component/seats-map/seat-map.service';
import { any } from 'video.js/dist/types/utils/events';
import { set } from 'video.js/dist/types/tech/middleware';
import { Cart } from '../../../../projects/shared-lib/src/lib/models/cart';
import { SeatSelectedAction } from '../../../../projects/shared-lib/src/lib/models/seats-selected';
import { TemplateViewSeat } from '../../templates/template-view-seat/template-view-seat';
import { I } from '@angular/cdk/keycodes';
import { MatAccordion } from '@angular/material/expansion';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'tw-button-floating-order',
    templateUrl: './button-floating-order.component.html',
    styleUrls: ['./button-floating-order.component.css'],
    imports: [
        NgStyle,
        MatButton,
        MatIconButton,
        MatIcon,
        MatProgressBar,
        CurrencyPipe,
        TranslatePipe,
        TranslateLangPipe,
        MatDialogContent,
        MatDialogActions,
        MatCardModule,
        MatDialogClose,
        MatDialogTitle,
        NgTemplateOutlet,
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        PageVenueParkingComponent,
        MatMiniFabButton,
        TemplateHeaderDialogComponent,
        JsonPipe,
        TemplateViewSeat,
        MatAccordion,
        MatDivider,
    ],
})
export class ButtonFloatingOrderComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('dialogError') dialogTemplate: TemplateRef<any>;
    @ViewChild('promoDialog') promoDialogTemplate: TemplateRef<any>;
    @ViewChild('promoConfirmDialog')
    promoConfirmDialogTemplate: TemplateRef<any>;
    @ViewChild('parkingDialog') parkingDialogTemplate!: TemplateRef<any>;
    @ViewChild('viewSeatTemplate') viewSeatTemplate: TemplateRef<any>;

    readonly dialog = inject(MatDialog);
    @Input() nameUnique;
    @Input() isDialog = false;
    @Input() typeTemaplate: 'items' | 'prices' = 'items';
    @Input() showPromoButton = false;
    @Input() performanceId?: number;
    @Input() subscriptionId?: number;
    @Input() userSuggestionParent = true;
    @Output() actionBtnRederectToCartOrSuggestion = new EventEmitter<any>();

    qtyReserved = 0;
    load = true;
    splitPrices = true;
    bestsSelect = true;
    total: number;
    _sub = [];
    combo2State: Combo2State;
    activeBtn = false;
    onlyGiftCertificates = false;
    includTax = true;
    promoInputValue = '';
    promoErrorMessage = '';
    promoLoading = false;
    appliedPromoCode = '';
    promoApplied = false;
    isPriceListExpanded = false;
    private promoDialogRef: MatDialogRef<any> = null;
    private viewSeatDialogRef: MatDialogRef<any> = null;
    selectedSeatMapViewImageUrl: string = '';
    availableParkings: Parking[] = [];
    private _selectedParkings: Parking[] = [];
    private _parkingEventIds: number[] = [];
    totalQtyReserveAndQtyCart = 0;
    totalAmountReservedAndCart = 0;

    constructor(
        public translate: TranslateService,
        public pageCombo2Service: PageCombo2Service,
        public buttonFloatingOrderService: ButtonFloatingOrderService,
        public router: Router,
        public pageSaleService: PageSaleService,
        public priceManagerService: PriceManagerService,
        public cartService: CartService,
        private seatMapService: SeatMapService,
        private actionCartService: ActionCartService,
    ) {}

    ngOnDestroy(): void {
        console.log('destroy floating order', this.nameUnique);
        this._sub.forEach((val) => {
            val.unsubscribe();
        });
    }

    ngOnInit(): void {
        this.includTax = this.pageSaleService.page?.includeTax;
        console.log(this.nameUnique);
        const routerEventsSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => {
                    const t = document.querySelectorAll('.btn-floating-order');
                    if (t && t.length < 2) {
                        const btFooterElm = document.getElementById('main-app-footer-button');
                        if (btFooterElm) {
                            btFooterElm.classList.add('main-app-footer-button-hide');
                            //this.qtyReserved = 0;
                            this.setQty(0);
                        }
                    }

                    ////console.log(t.length, t);
                }, 2000);
            }
        });
        this._sub.push(routerEventsSub);
        const a = this.buttonFloatingOrderService.action.asObservable().subscribe({
            next: (value) => {
                ////console.log('=============================', value);
                this.managerAction(value);
            },
        });
        const combo = this.pageCombo2Service.combo2StateSubject.asObservable().subscribe((value) => {
            this.combo2State = value;
            this.setQty(this.qtyReserved);
        });

        const page = this.pageSaleService.page_subject.subscribe((page) => {
            if (page?.includeTax) {
                this.includTax = page?.includeTax;
            }
        });
        const ss = this.buttonFloatingOrderService.typeTempate.subscribe((value) => {
            if (value) {
                //this.typeTemaplate = value;
            }
        });
        this._sub.push(page);
        this._sub.push(combo);
        this._sub.push(a);
        this._sub.push(ss);
        const promoSub = this.buttonFloatingOrderService.promoError$.subscribe((errMsg) => {
            this.promoLoading = false;
            if (errMsg === null) {
                this.appliedPromoCode = this.promoInputValue?.trim();
                this.promoInputValue = '';
                this.promoErrorMessage = '';
                this.promoApplied = true;
            } else {
                this.promoErrorMessage = errMsg;
            }
        });
        this._sub.push(promoSub);
        const cc = this.seatMapService.subSeatSelectedAction.subscribe((value: Partial<SeatSelectedAction>) => {
            console.log('SeatSelectedAction', value);

            if (value.type === 'remove') {
                let seatIds = value.seats.flatMap((s) => s.id);
                const prv = this.priceManagerService.getPricesSelected();
                seatIds?.forEach((element: any) => {
                    const p: PriceWeb = prv.find((pr: PriceWeb) => pr.seatIds?.includes(element));
                    if (p) {
                        p.seatIds = p.seatIds?.filter((id) => id !== element);
                        p.qty = p.seatIds?.length || 0;
                        // p.total = ((p.price ? p.price : 0) + (p?.serviceCharges || 0)) * p.qty;
                        if (p.qty === 0) {
                            this.priceManagerService.removePrice(p);
                        } else {
                            this.priceManagerService.addPriceWithoutObserver(p);
                        }
                    }
                });
                this.priceManagerService.getTotalForAllPrice();
            }
        });
        this._sub.push(cc);
        const dd = this.priceManagerService.watchTotal().subscribe(() => {
            const a = this.priceManagerService.getDetailReserved();
            this.total = a.total;
            this.setQty(a.qty);
        });
        const nn = this.cartService.cartSub.subscribe((value) => {
            const a = this.priceManagerService.getDetailReserved();
            this.total = a.total;
            this.setQty(a.qty);
        });
        this._sub.push(nn);

        this._sub.push(dd);
        const actionButtonFloatingOrder = this.buttonFloatingOrderService.action.value;
        if (actionButtonFloatingOrder) {
            this.managerAction(actionButtonFloatingOrder);
        }
    }

    managerAction(value: ActionButtonFloatingOrder) {
        /////console.log(value);
        if (value && value.name === ActionButtonFloatingOrderEnum.DATA) {
            const temp = this.priceManagerService.getDetailReserved();

            this.onlyGiftCertificates = temp.prices.filter((value1) => value1.giftCertificatesId === undefined).length === 0;
            // this.setQty(temp.qty);
            // this.total =temp.total;
            if (value.data.qtyReserved !== undefined) {
                // this.qtyReserved = value.data.qtyReserved;
                this.setQty(value.data.qtyReserved);
            }
            if (value.data.total !== undefined) {
                this.total = value.data.total;
                this.setTotalGlobal();
            }
            if (value.data.load !== undefined) {
                this.load = value.data.load;
            }
            if (value.data.splitPrices !== undefined) {
                this.splitPrices = value.data.splitPrices;
            }
            if (value.data.bestsSelect !== undefined) {
                this.bestsSelect = value.data.bestsSelect;
            }
            if (value.data.update) {
                /**** TODO SUPPRIMER DEJA OBSERVE PAR this.priceManagerService.watchTotal() */
                const a = this.priceManagerService.getDetailReserved();
                this.total = a.total;
                this.setQty(a.qty);
            }
        }
    }

    ngAfterViewInit(): void {
        const pageCon = document.querySelector('tw-page-prices-leves-container');
        ////console.log('======================================', pageCon);
        if (!pageCon) {
            const btFooterElm = document.getElementById('main-app-footer-button');
            btFooterElm?.classList.add('main-app-footer-button-hide');
        }
    }

    setQty(qty) {
        this.qtyReserved = qty;
        this.activeBtn = this.qtyReserved > 0;
        const counts = this.getFilteredCounts();
        this.totalQtyReserveAndQtyCart = this.qtyReserved + (counts.qty || 0);
        this.setTotalGlobal();
    }
    setTotalGlobal() {
        const counts = this.getFilteredCounts();
        this.totalAmountReservedAndCart = (this.total || 0) + (counts.amount || 0);
    }

    createHoldPage() {
        if (
            this.combo2State &&
            !this.combo2State.hasRightToGoOptional &&
            (this.combo2State.nbMandatory > 0 || this.combo2State.nbPseudo > 0 || this.combo2State.hasRightToGoPseudoMandatory)
        ) {
            this.dialog.open(this.dialogTemplate);
            return;
        }
        this.buttonFloatingOrderService.action.next({
            name: ActionButtonFloatingOrderEnum.HOLD,
            isDialog: this.isDialog,
        });
    }

    closeDialog() {
        this.buttonFloatingOrderService.action.next({
            name: ActionButtonFloatingOrderEnum.CLOSE,
        });
    }
    goToCart() {
        if (this.userSuggestionParent) {
            this.actionBtnRederectToCartOrSuggestion.emit(true);
            return;
        }
        const page = this.pageSaleService.page;
        let url = this.translate.currentLang + '/cart';
        const queryParams = {};
        if (page?.display === 'ITEMS') {
            const urlSuggestion = this.pageSaleService.getUrlPageSuggestion(
                page._links,
                null,
                this.cartService.cartSub.value,
                page.display,
                page.prices,
            );

            if (urlSuggestion) {
                url = this.translate.currentLang + '/pages/' + urlSuggestion;
                const params = urlSuggestion.split('?')[1];
                queryParams['suggestion'] = true;
                if (params?.search('promo') === -1) {
                    queryParams['promo'] = '';
                }
            }
            console.log(urlSuggestion, queryParams, url);
        }
        this.router
            .navigate([url], {
                queryParamsHandling: 'merge',
                queryParams: queryParams,
            })
            .then(() => {})
            .catch((error) => {
                // console.error(error);
            });
    }

    closeErrorDialog() {}

    openPromoDialog() {
        if (this.qtyReserved > 0) {
            this.dialog.open(this.promoConfirmDialogTemplate, {
                width: '480px',
                maxHeight: '90vh',
            });
            return;
        }
        this._openPromoInput();
    }

    continueWithPromo(clearSelection: boolean) {
        this.dialog.closeAll();
        if (clearSelection) {
            this.seatMapService.removeAllSeatReserveTemp();
            this.priceManagerService.clearPricesSelected();

            setTimeout(() => this._openPromoInput(), 50);
        }
    }

    private _openPromoInput() {
        this.promoInputValue = '';
        this.promoErrorMessage = '';
        this.promoLoading = false;
        this.promoApplied = false;
        this.promoDialogRef = this.dialog.open(this.promoDialogTemplate, {
            width: '420px',
            maxHeight: '90vh',
        });
    }

    applyPromo() {
        const code = this.promoInputValue?.trim();
        if (code) {
            this.promoLoading = true;
            this.promoErrorMessage = '';
            this.buttonFloatingOrderService.promoCode$.next(code);
        }
    }

    getRange(count: number): number[] {
        return Array.from({ length: count }, (_, i) => i);
    }

    removeOneUnit(price: PriceWeb, i: number): void {
        const live: CartPrice = this.priceManagerService.priceSelected.find((p) => this.priceManagerService.hasSamePrice(p, price));
        if (!live) {
            return;
        }
        this.removeBySeats(live.seatIds, i);
        const step = live.divisor && live.divisor > 0 ? live.divisor : 1;
        live.qty = this.priceManagerService.getFutureQtyMinusOne(live);
        live.total = (live.price + (live.serviceCharges || 0)) * live.qty;
        if (!live.seatIds || live.seatIds?.length === 0) {
            // this.priceManagerService.qtyMinusOne(live);
            this.priceManagerService.addPriceWithoutObserver(live);
        }

        // const detail = this.priceManagerService.getDetailReserved();
        // this.total = detail.total;
        // this.setQty(detail.qty);
        this.priceManagerService.getTotalForAllPrice();
    }
    removeBySeats(seatIds: number[], i: number): void {
        console.log('removeBySeats', seatIds, i);
        if (seatIds && seatIds.length > 0) {
            const takenId = seatIds[0];
            // live.seatIds = live.seatIds.filter((id) => id !== takenId);
            // live.qty = live.seatIds.length;
            const sg = this.seatMapService.getGroupSeatSelected();
            const s: any = sg.find((group) => group.seatIds?.includes(takenId));
            this.seatMapService.subSeatSelectedToRemove.next({
                seats: [s],
                oberve: false,
            });
        }
    }
    getViewImageUrl(price: PriceWeb, i: number): string {
        const live = this.priceManagerService.priceSelected.find((p) => this.priceManagerService.hasSamePrice(p, price));
        if (!live || !live.seatIds || live.seatIds.length === 0) {
            return null;
        }
        return this.seatMapService.getSeatById(live.seatIds?.[i])?.viewImageUrl;
    }
    getViewImageUrlByCartDetail(cartDetail: CartDetailToken): string {
        return cartDetail?.seat ? cartDetail.seat?.viewImageUrl : null;
    }
    createHoldPageWithParkingCheck(): void {
        const prices: PriceWeb[] = this.priceManagerService.getPricesSelected() as PriceWeb[];
        const eventIds: number[] = [...new Set(prices.filter((p) => p.eventId != null).map((p) => p.eventId as number))];
        if (eventIds.length === 0) {
            this.createHoldPage();
            return;
        }
        this.pageSaleService.getParkingByListEvents(eventIds).subscribe({
            next: (parkings) => {
                if (!parkings || parkings.length === 0) {
                    this.createHoldPage();
                    return;
                }
                this.availableParkings = parkings;
                this._parkingEventIds = eventIds;
                this._selectedParkings = [];
                this.dialog.open(this.parkingDialogTemplate, { width: '500px', maxHeight: '90vh' });
            },
            error: () => {
                this.createHoldPage();
            },
        });
    }

    onParkingSelectionChange(selected: Parking[]): void {
        this._selectedParkings = selected;
    }

    confirmParking(): void {
        this._selectedParkings.forEach((prk) => this.priceManagerService.addPriceParking(prk, prk.date, 1));
        this.priceManagerService.getTotalForAllPrice();
        this.dialog.closeAll();
        this.createHoldPage();
    }

    skipParking(): void {
        const toRemove = this.priceManagerService.priceSelected.filter(
            (p) => p.parkingId != null && p.eventId != null && this._parkingEventIds.includes(p.eventId),
        );
        toRemove.forEach((p) => this.priceManagerService.removePrice(p));
        this.priceManagerService.getTotalForAllPrice();
        this.dialog.closeAll();
        this.createHoldPage();
    }

    hasParkingSelected(): boolean {
        return this._selectedParkings.length > 0;
    }

    removePromo(): void {
        this.appliedPromoCode = '';
        this.buttonFloatingOrderService.promoCode$.next(null);
    }

    togglePriceList(): void {
        this.isPriceListExpanded = !this.isPriceListExpanded;
    }

    closePromoDialog(): void {
        this.promoApplied = false;
        this.promoDialogRef?.close();
    }

    get cartDetailTokenFlat(): { token: CartDetailToken; price: CartPrice }[] {
        const result: { token: CartDetailToken; price: CartPrice }[] = [];
        const cart: Cart = this.cartService.cartSub.value;
        if (!cart?.cartElements) {
            return result;
        }
        cart.cartElements.forEach((element: CartElement) => {
            element.prices?.forEach((price: CartPrice) => {
                if (!this.matchesFilterPrice(price) || price.donation) {
                    return;
                }
                price.cartDetailToken?.forEach((token: CartDetailToken) => {
                    result.push({ token, price });
                });
            });
        });
        return result;
    }

    get cartDonationFlat(): { price: CartPrice }[] {
        const result: { price: CartPrice }[] = [];
        const cart: Cart = this.cartService.cartSub.value;
        if (!cart?.cartElements) {
            return result;
        }
        cart.cartElements.forEach((element: CartElement) => {
            element.prices?.forEach((price: CartPrice) => {
                if (!this.matchesFilterPrice(price) || !price.donation) {
                    return;
                }
                result.push({ price });
            });
        });
        return result;
    }

    get cartParkingFlat(): Parking[] {
        const result: Parking[] = [];
        const cart = this.cartService.cartSub.value;
        if (!cart?.cartElements) {
            return result;
        }
        const noFilter =
            (this.performanceId === undefined || this.performanceId === null) &&
            (this.subscriptionId === undefined || this.subscriptionId === null);
        cart.cartElements.forEach((element: CartElement) => {
            element.parking?.forEach((p: any) => {
                if (noFilter || (this.performanceId !== undefined && this.performanceId !== null && p?.eventId === this.performanceId)) {
                    result.push(p);
                }
            });
        });
        return result;
    }

    private matchesFilterPrice(price: any): boolean {
        if (
            (this.performanceId === undefined || this.performanceId === null) &&
            (this.subscriptionId === undefined || this.subscriptionId === null)
        ) {
            return true;
        }
        const byPerformance = this.performanceId !== undefined && this.performanceId !== null && price?.eventId === this.performanceId;
        const bySubscription =
            this.subscriptionId !== undefined && this.subscriptionId !== null && price?.subscriptionId === this.subscriptionId;
        return !!(byPerformance || bySubscription);
    }

    private getFilteredCounts(): { qty: number; amount: number } {
        const result = { qty: 0, amount: 0 };
        const cart: Cart = this.cartService.cartSub.value;
        if (!cart?.cartElements) {
            return result;
        }
        cart.cartElements.forEach((element: CartElement) => {
            // prices
            element.prices?.forEach((price: CartPrice) => {
                if (!this.matchesFilterPrice(price)) {
                    return;
                }
                const tokensCount = price.donation ? 1 : price?.cartDetailToken?.length ?? price?.qty ?? 0;
                result.qty += tokensCount;
                const priceTotal = price?.total != null ? price.total : ((price?.price ?? 0) + (price?.serviceCharges ?? 0)) * tokensCount;
                result.amount += priceTotal || 0;
            });
            // parking items (match by eventId if provided)
            element.parking?.forEach((p: any) => {
                const includeAll =
                    (this.performanceId === undefined || this.performanceId === null) &&
                    (this.subscriptionId === undefined || this.subscriptionId === null);
                if (includeAll || (this.performanceId !== undefined && p?.eventId === this.performanceId)) {
                    result.qty += 1;
                    result.amount += p?.price ?? 0;
                }
            });
        });
        return result;
    }

    deleteCartDetailToken(token: CartDetailToken): void {
        const item = this.cartDetailTokenFlat.find((i) => i.token === token);
        if (!item) {
            return;
        }
        const price: CartPrice = { ...item.price, cartDetailToken: [token] };
        this.actionCartService.actionRequest(<ActionCartRequest>{
            type: EnumTypeActionCart.deleteElement,
            prices: [price],
            redirect: false,
        });
        setTimeout(() => {
            this.seatMapService.setSubCart(this.cartService.cartSub.value);
        }, 1200);
    }

    deleteDonationPrice(price: CartPrice): void {
        this.actionCartService.actionRequest(<ActionCartRequest>{
            type: EnumTypeActionCart.deleteElement,
            prices: [price],
            redirect: false,
        });
        setTimeout(() => {
            this.seatMapService.setSubCart(this.cartService.cartSub.value);
        }, 1200);
    }

    deleteCartDetailParkingToken(parking: Parking): void {
        const price = <CartPrice>(<unknown>{
            eventId: parking.eventId,
            parkingId: parking.id,
            cartDetailToken: [<CartDetailToken>{ idCartLine: parking.hold }],
        });
        this.actionCartService.actionRequest(<ActionCartRequest>{
            type: EnumTypeActionCart.deleteElement,
            prices: [price],
            redirect: false,
        });
    }
    showSeatMap(url: any) {
        this.selectedSeatMapViewImageUrl = url;
        this.viewSeatDialogRef = this.dialog.open(this.viewSeatTemplate, {
            width: '600px',
            maxHeight: '90vh',
        });
    }
}
